import React, { useEffect, useRef, useState } from 'react';
import { Button, Card, Container, ContainerFlex, TextLocalized } from '../components/styled/Styled';

import BlockPerformance from '../components/BlockPerformance';
import { getStorageUser } from '../components/util/UserUtil';
import { HttpConnection, HttpMethod, HttpOperations } from '../components/util/HttpConnection';
import { getProgressData } from '../components/util/BlockUtil';
import Icon from '@mdi/react';
import { mdiDownload } from '@mdi/js';
import { printComponent } from '../components/util/PrintUtil';

const PerformanceView = () => {
    const [items, setItems] = useState([]);
    const [progressWidth, setProgressWidth] = useState(0);
    const progressContainerRef = useRef();
    const resultRef = useRef();

    const [progress, setProgress] = useState({ text: "msgProgress0", color: "color-red", score: 0 });

    useEffect(() => {
        HttpConnection(`${HttpOperations.block}/score`,
            result => {
                //Get score
                let currentPoints = result.item.reduce((carry, value) => {
                    return carry + value.currentPoints;
                }, 0);

                let totalPoints = result.item.reduce((carry, value) => {
                    return carry + value.totalPoints;
                }, 0);

                let value = ((currentPoints / totalPoints) * 100).toFixed(0);
                let auxProgress = getProgressData(value);
                auxProgress.score = value;
                setProgress(auxProgress);

                setItems(result.item);
            }, error => console.log(error), HttpMethod.get);
    }, [])

    useEffect(() => {
        if (progressContainerRef.current) {
            setProgressWidth(progressContainerRef.current.offsetWidth * progress.score / 100);
        }
    }, [progress]);

    const printResult = () => printComponent(resultRef);

    return items.length > 0 ? (
        <div ref={resultRef}>
            <ContainerFlex width="12" justify="center" px="32">
                <Container width="12" lg="8">
                    <Card width="12" shadowOn flex mv="16" align="center" color="color-white">

                        <Card flex width="12" px="16" align="center" color="color-green-dark" fontColor="color-white" radiusbl="0px" radiusbr="0px">
                            <Container width="wrap" flex justify="center" align="center">
                                <Container fontSize="18px" fontWeight="300" children={<TextLocalized children="msgPerformance" />} />
                                <Container mt="8" fontSize="12px" children={<TextLocalized children="msgPerformanceSubtitle" />} />
                            </Container>

                            <Button title="Download" flex onClick={printResult} px="8" align="center" fontColor="color-green-dark" color={"color-gray-card"} children={<Icon size={1} path={mdiDownload} />} />
                        </Card>

                        <Container width="wrap" pv="8" ph="16">
                            <Container width="12" fontColor="color-black" fontSize="48px" fontWeight="300" children={getStorageUser().username} />
                        </Container>

                        <ContainerFlex px="32" direction="column" justify="center" align="center" fontColor="color-green-dark">
                            <Card flex justify="center" align="center" mh="16"
                                border="solid" borderColor="color-black" borderWidth="7px" radius="50%"
                                fontSize="40px" fontColor="color-black" fontWeight="bold"
                                height="150px" width="150px" children={`${progress.score}%`} />
                            <Container mt="8" fontSize="12px" children={"0%-100%"} />
                        </ContainerFlex>

                        <Card width="12" height="1px" color="color-gray" radius="2px" />
                        <ContainerFlex width="12" px="16" align="center">
                            <Container width="3" fontSize="12px" fontWeight="300" children={<TextLocalized children="msgCompanyLevel" />} />
                            <div className='col' style={{ padding: "0 8px" }} ref={progressContainerRef}>
                                <ContainerFlex position="relative" width="wrap">
                                    <Container width="3">
                                        <Card flex fontSize="10px" justify="space-between" align="items-center">
                                            <Container children="0%" />
                                            <Container children="25%" />
                                        </Card>
                                    </Container>
                                    <Container width="wrap" ph="1" />
                                    <Container width="3">
                                        <Card flex fontSize="10px" justify="space-between" align="items-center">
                                            <Container children="75%" />
                                            <Container children="100%" />
                                        </Card>
                                    </Container>
                                </ContainerFlex>
                                <ContainerFlex position="relative" width="wrap">
                                    <Container width="3">
                                        <Card flex height="20px" color="color-red" border="solid" borderColor="color-red" borderWidth="2px" width="wrap" radius="4px" radiustr="0" radiusbr="0" />
                                    </Container>
                                    <Container width="6" ph="1">
                                        <Card height="20px" color="color-orange" border="solid" borderColor="color-orange" borderWidth="2px" width="wrap" radius="0" />
                                    </Container>
                                    <Container width="3">
                                        <Card height="20px" color="color-green" border="solid" borderColor="color-green" borderWidth="2px" width="wrap" radius="4px" radiustl="0" radiusbl="0" />
                                    </Container>

                                    <Card position="absolute" top="37.5%" left="1px" width={`${progressWidth}px`} height="5px" radius="2px" color="color-black" />
                                </ContainerFlex>
                            </div>

                            <Card px="8" border="solid" fontColor="color-white"
                                color={progress.color} borderColor={progress.color} borderWidth="2px" fontSize="12px"
                                children={<TextLocalized children={progress.text} />} />
                        </ContainerFlex>
                    </Card>

                    <ContainerFlex width="12" align="stretch" children={items.map((item, index) => <BlockPerformance key={index} item={item} />)} />
                </Container>
            </ContainerFlex>
        </div>
    ) : null;
};

export default PerformanceView;